import React, {Component} from 'react';
import {Segment} from 'semantic-ui-react';
import {Uploader} from 'go/components/common/attachments';
import _ from 'lodash';
import {FemaGoTable} from 'app-ui-componentlibrary';
import {convertDateForDisplay} from 'common/utils';
import {produce} from 'immer';

import {
  FileTransferUtils,
  convertFileSize,
} from 'go/components/common/attachments/uploader/utils';
import REST from 'go/requests/rest';
import {downloadPresignedLink, usePresignedUrl} from 'common/utils';
import {produceAppliedDiff} from 'framework/collaboration/diff.utils';

export class ReviewAttachments extends Component {
  constructor(props, context) {
    super(props, context);
    let filesSplit = _.partition(props.currentFiles, (file) => file.deletable);

    // The system currently only marks things as deletable: false if they've been submitted
    // If that changes, this logic may need to be revisited.
    this.state = {
      unsubmittedUploaded: filesSplit[0],
      submittedUploaded: filesSplit[1],
    };
  }

  componentDidUpdate(prevProps) {
    let {currentlyCollaborating} = this.props;
    if (!_.isEqual(prevProps.currentFiles, this.props.currentFiles)) {
      if (currentlyCollaborating) {
        let currCurrrentFiles = _.partition(
          this.props.currentFiles,
          (file) => file.deletable
        );
        let prevCurrrentFiles = _.partition(
          prevProps.currentFiles,
          (file) => file.deletable
        );
        let deletableFiles = produceAppliedDiff(
          prevCurrrentFiles[0],
          currCurrrentFiles[0],
          this.state.unsubmittedUploaded
        );
        let nonDeletableFiles = produceAppliedDiff(
          prevCurrrentFiles[1],
          currCurrrentFiles[1],
          this.state.submittedUploaded
        );
        this.setState({
          unsubmittedUploaded: deletableFiles,
          submittedUploaded: nonDeletableFiles,
        });
      } else {
        let filesSplit = _.partition(this.props.currentFiles, (file) => file.deletable);
        this.setState({
          unsubmittedUploaded: filesSplit[0],
          submittedUploaded: filesSplit[1],
        });
      }
    }
  }
  downloadAttachmentLink = (resourceId, fileName) => {
    const downloadUrl = REST.attachment.getAttachmentDownloadUrl(resourceId);
    return (
      <a href={downloadUrl} title={`Download ${fileName}`}>
        {fileName}
      </a>
    );
  };

  renderSubmittedTable(filesSuccessful) {
    const {
      fileSizeLimit,
      showSubmittedFileSize,
      attachmentType,
      hideAction,
      sortBy,
      sortOrder,
      currentlyCollaborating,
    } = this.props;
    if (currentlyCollaborating) {
      filesSuccessful = _.orderBy(filesSuccessful, sortBy, sortOrder);
    }

    // to generate a read only view of the attachments section w/disabled description
    return (
      <div className="padding-bottom">
        {this.props.readOnly ? (
          <FemaGoTable
            type="static"
            basic="very"
            className="padding-bottom"
            summary={attachmentType ? attachmentType + ' review' : 'Attachments review'}
          >
            <FemaGoTable.Header>
              <FemaGoTable.Row>
                <FemaGoTable.HeaderCell>Filename</FemaGoTable.HeaderCell>
                <FemaGoTable.HeaderCell>Date uploaded</FemaGoTable.HeaderCell>
                {showSubmittedFileSize && (
                  <FemaGoTable.HeaderCell>File size</FemaGoTable.HeaderCell>
                )}
                <FemaGoTable.HeaderCell>Uploaded by</FemaGoTable.HeaderCell>
                <FemaGoTable.HeaderCell>Label</FemaGoTable.HeaderCell>
                <FemaGoTable.HeaderCell>Description</FemaGoTable.HeaderCell>
                {!hideAction && <FemaGoTable.HeaderCell>Action</FemaGoTable.HeaderCell>}
              </FemaGoTable.Row>
            </FemaGoTable.Header>
            <FemaGoTable.Body>
              {_.map(filesSuccessful, (file, index) => {
                const {
                  fileName,
                  fileSize,
                  uploadedDate,
                  resourceId,
                  attachmentType,
                  description,
                  uploadedBy,
                } = file;

                const toDisplayName = this.props.showAttachmentType
                  ? attachmentType
                  : fileName;

                const date = convertDateForDisplay(new Date(uploadedDate * 1000), true);
                return (
                  <FemaGoTable.Row key={index}>
                    <FemaGoTable.TextCell width={5}>
                      {this.downloadAttachmentLink(resourceId, fileName)}
                    </FemaGoTable.TextCell>
                    <FemaGoTable.TextCell width={1}>{date}</FemaGoTable.TextCell>
                    {showSubmittedFileSize && (
                      <FemaGoTable.TextCell width={1}>
                        {convertFileSize(fileSize, fileSizeLimit)}
                      </FemaGoTable.TextCell>
                    )}
                    <FemaGoTable.TextCell width={1}>{uploadedBy}</FemaGoTable.TextCell>
                    <FemaGoTable.TextCell width={3}>
                      {attachmentType}
                    </FemaGoTable.TextCell>
                    <FemaGoTable.TextCell>
                      {description || <i>No description given.</i>}
                    </FemaGoTable.TextCell>
                  </FemaGoTable.Row>
                );
              })}
            </FemaGoTable.Body>
          </FemaGoTable>
        ) : (
          <FemaGoTable type="entry" summary="Review attachments">
            <FemaGoTable.Header>
              <FemaGoTable.Row>
                <FemaGoTable.HeaderCell>Filename</FemaGoTable.HeaderCell>
                <FemaGoTable.HeaderCell>Date uploaded</FemaGoTable.HeaderCell>
                {showSubmittedFileSize && (
                  <FemaGoTable.HeaderCell>File size</FemaGoTable.HeaderCell>
                )}
                <FemaGoTable.HeaderCell>Label</FemaGoTable.HeaderCell>
                <FemaGoTable.HeaderCell>Description</FemaGoTable.HeaderCell>
                {!hideAction && <FemaGoTable.HeaderCell>Action</FemaGoTable.HeaderCell>}
              </FemaGoTable.Row>
            </FemaGoTable.Header>
            <FemaGoTable.Body>
              {_.map(filesSuccessful, (file, index) => {
                const {
                  fileName,
                  fileSize,
                  uploadedDate,
                  resourceId,
                  attachmentType,
                  description,
                } = file;

                const date = convertDateForDisplay(new Date(uploadedDate * 1000), true);
                return (
                  <FemaGoTable.Row key={index}>
                    <FemaGoTable.TextCell width={5}>
                      {this.downloadAttachmentLink(resourceId, fileName)}
                    </FemaGoTable.TextCell>
                    <FemaGoTable.TextCell width={1}>{date}</FemaGoTable.TextCell>
                    {showSubmittedFileSize && (
                      <FemaGoTable.TextCell width={1}>
                        {convertFileSize(fileSize, fileSizeLimit)}
                      </FemaGoTable.TextCell>
                    )}
                    <FemaGoTable.TextCell width={3}>
                      {attachmentType}
                    </FemaGoTable.TextCell>
                    <FemaGoTable.InputCell
                      value={description}
                      maxLength={501}
                      id={file.fileName + index + '.description'}
                      name="description"
                      handleChange={(e, res) => {
                        this.handleDescriptionChange(index, res);
                      }}
                      handleBlur={() => {
                        this.props.updateDescription(
                          FileTransferUtils.createPayload(
                            this.state.submittedUploaded[index]
                          )
                        );
                      }}
                    />
                  </FemaGoTable.Row>
                );
              })}
            </FemaGoTable.Body>
          </FemaGoTable>
        )}
      </div>
    );
  }

  handleDescriptionChange = (index, res) => {
    const {name, value} = res;
    if (this.props.currentlyCollaborating) {
      this.setState((prevState) => ({
        submittedUploaded: produce(prevState.submittedUploaded, (draft) => {
          draft[index][name] = value;
        }),
      }));
    } else {
      let submittedUploaded = this.state.submittedUploaded;
      submittedUploaded[index][name] = value;
      this.setState({
        submittedUploaded,
      });
    }
  };

  render() {
    const {
      attachmentType,
      acceptedFileTypes,
      fileSizeLimit,
      numAllowed,
      numRequired,
      resync,
      header,
      readOnly,
      errorMessage,
      is1GbAttachmentAccepted,
      avoid1GbAttachmentSaveError,
      extended_attachment,
      updateRedux,
      showUnsubmitted,
      showAcceptedFileTypes,
      hrefId,
      showOnlyDeletableAttachments,
      buttonMsg,
      hideDeleteforNumRequired,
      hideAction,
      sessionDataPath,
      currentlyCollaborating,
      sortBy,
      sortOrder,
    } = this.props;
    const {unsubmittedUploaded, submittedUploaded} = this.state;
    const filteredUnsubmittedUploaded = _.filter(
      unsubmittedUploaded,
      (attachment) => attachment.attachmentType === attachmentType
    );
    const filteredSubmittedUploaded = _.filter(
      submittedUploaded,
      (attachment) => attachment.attachmentType === attachmentType
    );
    // omits the uploader widget if the attachments section is readonly
    if (readOnly === true || readOnly === 'true') {
      let attachmentsToShow = submittedUploaded;
      if (showUnsubmitted) {
        attachmentsToShow = submittedUploaded.concat(unsubmittedUploaded);
      }
      return <Segment vertical>{this.renderSubmittedTable(attachmentsToShow)}</Segment>;
    } else {
      return (
        <Segment vertical>
          {!showOnlyDeletableAttachments &&
            submittedUploaded.length > 0 &&
            this.renderSubmittedTable(submittedUploaded)}
          <Uploader
            attachmentType={attachmentType || ''}
            uploadAttachment={this.props.uploadAttachment}
            deleteAttachment={this.props.deleteAttachment}
            updateDescription={this.props.updateDescription}
            savedAttachments={filteredUnsubmittedUploaded}
            nonDeletableAttachments={filteredSubmittedUploaded}
            buttonMsg={buttonMsg}
            acceptedFileTypes={acceptedFileTypes}
            fileSizeLimit={fileSizeLimit}
            numAllowed={numAllowed}
            numRequired={numRequired}
            resync={resync}
            header={header}
            errorMessage={errorMessage}
            is1GbAttachmentAccepted={is1GbAttachmentAccepted}
            avoid1GbAttachmentSaveError={avoid1GbAttachmentSaveError}
            extended_attachment={extended_attachment}
            showAcceptedFileTypes={showAcceptedFileTypes}
            updateRedux={updateRedux}
            saveDataErrors={this.props.saveDataErrors}
            hideUploadedBy={this.props.hideUploadedBy}
            hrefId={hrefId}
            hideDeleteforNumRequired={hideDeleteforNumRequired}
            hideAction={hideAction}
            sessionDataPath={sessionDataPath}
            currentlyCollaborating={currentlyCollaborating}
            sortBy={sortBy}
            sortOrder={sortOrder}
          />
        </Segment>
      );
    }
  }
}

export default ReviewAttachments;
